import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";
import platformConstants from "../constants/platformConstants";

const initialState: {
  platforms: any[];
  platformCount: number;
  allPlatforms: any[];
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  platformsPending: Boolean;
} = {
  platforms: [],
  platformCount: 0,
  allPlatforms: [],
  error: false,
  pending: false,
  fulfilled: false,
  platformsPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case platformConstants.GET_PLATFORMS_LIST:
      return {
        ...state,
        platformsPending: true,
      };
    case platformConstants.GET_PLATFORMS_LIST_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          platformsPending: false,
          platforms: action.payload.data.results,
          platformCount: action.payload.data.count,
        };
      return { ...state, allPlatforms: action.payload.data };

    case platformConstants.GET_PLATFORMS_LIST_FAILURE:
      return {
        ...state,
        platformsPending: false,
      };
    case platformConstants.CREATE_PLATFORM_REQUEST:
    case platformConstants.EDIT_PLATFORM_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case platformConstants.CREATE_PLATFORM_SUCCESS:
    case platformConstants.EDIT_PLATFORM_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case platformConstants.CREATE_PLATFORM_FAILURE:
    case platformConstants.EDIT_PLATFORM_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case platformConstants.RESET_PLATFORM_REQUEST:
      return {
        ...state,
        error: false,
        pending: false,
        fulfilled: false,
      };
    case platformConstants.RESET_PLATFORM_LIST:
      return {
        ...state,
        platforms: [],
        platformCount: 0,
        allPlatforms: [],
      };
    default:
      return {
        ...state,
      };
  }
};
